<template>
    <div class="w-full antialiased">
        <div class=" flex justify-center  w-full">
            <div class="w-full">

                <Head>
                    <title>{{ title }}</title>
                </Head>
                <div class=" w-full fixed z-50">
                    <NavBarTop />
                </div>
            </div>
        </div>
        <div class="relative block overflow-hidden w-full mt-20">
            <main class="h-full w-full relative">
                <div class="flex justify-between ">
                    <slot name="navigation"></slot>
                </div>
                <div :class="[classes ?? 'container mx-auto']">
                    <slot />
                </div>
            </main>
        </div>
    </div>
</template>
<script setup>
import NavBarTop from "@/Components/NavBarTop.vue";
import { ref, onMounted, reactive } from "vue";
import { Head } from "@inertiajs/inertia-vue3";

defineProps({
    title: {
        type: String,
        default: "Gestion du stock",
    },
    classes:{}
});
</script>
